import React from 'react'
import { AddDropdown } from '../../../../../commonComponents/dropdown/AddDropdown'

const types = {
    addEU:'addEU',
    addNL:'addNL',
    pkgType:'packageTypes',
    undg:'UNDG'
}

const SearchableDropdown = (props) => {

    const { fieldName: { key, text, value }, fieldValue, setFieldValue } = props
    return (
        <AddDropdown
            id={`${key}`}
            // type='UNDG'
            type={types[`${key}`]}
            label={`${text}`}
            // boxNumber={boxNumber}            
            selectedValue={fieldValue}
            disabled={!value?.trim()}
            onSelect={({ value }) => {
                // updateData({ undg: value })
                // onChange("undgId", { undg: value, undgId })
                setFieldValue(value)
            }}
            onBlur={({ value }) => {
                if (!value?.trim()) {
                    // updateData({ undg: value })
                    // onChange("undgId", { undg: value || " ", undgId })
                    setFieldValue(value)
                }
            }}
        />
    )
}

export default SearchableDropdown